/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAiScanTargetsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAiScanTargetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAiScanTargetsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAiScanTargetsSecurity$outboundSchema: z.ZodMiniType<
  ListAiScanTargetsSecurity$Outbound,
  ListAiScanTargetsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAiScanTargetsSecurityToJSON(
  listAiScanTargetsSecurity: ListAiScanTargetsSecurity,
): string {
  return JSON.stringify(
    ListAiScanTargetsSecurity$outboundSchema.parse(listAiScanTargetsSecurity),
  );
}

/** @internal */
export type ListAiScanTargetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAiScanTargetsRequest$outboundSchema: z.ZodMiniType<
  ListAiScanTargetsRequest$Outbound,
  ListAiScanTargetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listAiScanTargetsRequestToJSON(
  listAiScanTargetsRequest: ListAiScanTargetsRequest,
): string {
  return JSON.stringify(
    ListAiScanTargetsRequest$outboundSchema.parse(listAiScanTargetsRequest),
  );
}
